<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-04 14:38:03
 * @Description: 地图场站弹框今日信息展示
 * @FilePath: \sheyang\src\module\overview\stationChargeModal\components\infoItems.vue
-->
<template>
  <div class="station-info-items">
    <div class="info-item" v-for="item in itemData" :key="item.id">
      <div class="value-row">
        <span class="value">{{ item.value | toNumber }}</span>
        <span class="unit">{{ item.unit }}</span>
      </div>
      <div class="label">{{ item.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stationInfoItems',
  props: {
    stationInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      itemData: [
        {
          id: 0, name: '今日充电量', value: '0', unit: '度',
        },
        {
          id: 1, name: '昨日充电量', value: '0', unit: '度',
        },
        {
          id: 2, name: '当前总功率', value: '0', unit: 'kW',
        },
        {
          id: 3, name: '充电枪总数', value: '0', unit: '台',
        },
        {
          id: 4, name: '累计充电量', value: '0', unit: '度',
        },
        {
          id: 5, name: '累计充电次数', value: '0', unit: '次',
        },
        {
          id: 6, name: '今日离线设备数', value: '0', unit: '台',
        },
        {
          id: 7, name: '设备离线率', value: '0', unit: '%',
        },
      ],
    };
  },
  filters: {
    // 保留一位小数 String
    toNumber(val) {
      return val ? Number(val).toFixed(0) : '0';
    },
  },
  watch: {
    stationInfo: {
      handler(val, newVal) {
        this.itemData[0].value = val.electricInternalTod;
        this.itemData[1].value = val.electricInternalTodYesterday;
        this.itemData[2].value = val.kwReal;
        this.itemData[3].value = val.equipmentNum;
        this.itemData[4].value = val.chargingAmount;
        this.itemData[5].value = val.chargeAmount;
        this.itemData[6].value = val.adcOffLine;
        this.itemData[7].value = val.adcOffLineRatio * 100;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.station-info-items {
  padding-bottom: 33px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 15px;
  .info-item {
    width: 228px;
    height: 84px;
    box-sizing: border-box;
    padding-top: 15px;
    .backgroundImage('@/assets/images/sataionInfoItemBg.png');
    .value-row {
      .displayFlex(center, baseline);
      .value {
        font-size: 28px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #FFFFFF;
        text-shadow: 0px 0px 8px #00B2FF;
      }
      .unit {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-shadow: 0px 0px 8px #00B2FF;
      }
    }
    .label {
      width: 100%;
      margin-top: 5px;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      text-shadow: 0px 0px 8px #00B2FF;
    }
  }
}
</style>
